import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

const useCustomerInfoFormStyles = makeStyles({
    root: {
        width: '100%'
    },
    inquiryContactInfo: {
        display: 'grid',
        gridTemplateColumns: 'repeat(6, 1fr)',
        gridTemplateRows: 'repeat(6, 1fr)',
        columnGap: tokens.spacingHorizontalXXL,
        rowGap: tokens.spacingVerticalM,
        marginBottom: tokens.spacingVerticalM,
        width: '100%',
        '@media screen and (max-width: 480px)': {
            display: 'flex',
            flexDirection: 'column'
        }
    },
    firstNameContainer: { ...shorthands.gridArea('1', '1', '2', '4') },
    lastNameContainer: { ...shorthands.gridArea('1', '4', '2', '7') },
    address1Container: { ...shorthands.gridArea('2', '1', '3', '7') },
    address2Container: { ...shorthands.gridArea('3', '1', '4', '7') },
    cityContainer: { ...shorthands.gridArea('4', '1', '5', '3') },
    stateContainer: { ...shorthands.gridArea('4', '3', '5', '5'), minWidth: 'unset' },
    zipcodeContainer: { ...shorthands.gridArea('4', '5', '5', '7') },
    phoneNumberContainer: { ...shorthands.gridArea('5', '1', '6', '4') },
    emailContainer: { ...shorthands.gridArea('5', '4', '6', '7') },
    dobContainer: { ...shorthands.gridArea('6', '1', '7', '3') },
    employerContainer: { ...shorthands.gridArea('6', '3', '7', '5') },
    driversLicenseNumber: {
        ...shorthands.gridArea('7', '1', '8', '4')
    },
    driversLicenseState: {
        ...shorthands.gridArea('7', '4', '8', '5')
    }
});

export default useCustomerInfoFormStyles;
